module.exports = __webpack_public_path__ + "modules/bbs/img/error2.png";